// @flow

import { connect } from "react-redux";
import React from "react";

import { getStatusTitle } from "src/reducers";

import type { AppState } from "src/types";

type Props = {
  title: string
};

const Name = ({ title }: Props) => <span title={title}>{title}</span>;

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  title: getStatusTitle(app, `${props.id}`)
});

export default connect(mapStateToProps)(Name);
